import api from '@/api';
import session from '@/storage/session';
import store from '@/bootstrap/vuex';

export default {
    namespaced: true,
    actions: {
        search(filters) {
            return api.get('/countries', filters);
        },
        fetch(countryId) {
            return api.get(`/countries/${countryId}`, null);
        },
        fetchCached() {
            if (session.missing('countries')) {
                return api.fetch('/countries', {
                    'cache-response': true,
                    'cache-key': 'countries',
                });
            } else {
                const response = session.fetch('countries');
                return Promise.resolve(response);
            }
        },
        fetchLists() {
            return api.batch([store.dispatch('subscribers/fetchCached', null, { root: true }), store.dispatch('users/fetchCached', null, { root: true })]);
        },
        save(country) {
            return api
                .post('/countries', country)
                .then((response) => {
                    session.destroy('country');
                    return Promise.resolve(response);
                })
                .catch((error) => {
                    if (error.response) {
                        return Promise.reject(error.response);
                    }
                    return Promise.reject(null);
                });
        },
        update(countryId, country) {
            return api
                .put(`/countries/${countryId}`, country)
                .then((response) => {
                    session.destroy('country');
                    return Promise.resolve(response);
                })
                .catch((error) => {
                    if (error.response) {
                        return Promise.reject(error.response);
                    }
                    return Promise.reject(null);
                });
        },
        archive(countryId) {
            return api.put(`/countries/archive/${countryId}`, null);
        },
        delete(countryId) {
            return api.delete(`/countries/${countryId}`, null);
        },
    },
};
